module.exports = __webpack_public_path__ + "static/media/iconBack.0a2c98e0.svg";